module.exports = __webpack_public_path__ + "img/hk.b63bb3db.png";